import React, { Fragment } from 'react'
import { useHistory, withRouter } from "react-router";
import { Link } from "react-router-dom";
import filter from 'ramda/src/filter'
import pipe from 'ramda/src/pipe'
import { Table, Button, Input, Space, PageHeader, message } from 'antd'
import {
    // CopyOutlined,
    DeleteOutlined,
    EditOutlined
} from '@ant-design/icons';
import { networkAndroidAttributes, networkAndroidAttribute } from 'src/data'
import Services from 'src/services'
import { useRadioButton, useRequest } from 'src/hooks';
import { ConfirmPop } from '../ConfirmPop';
import { compareBy, mapColumn } from 'src/utils';
import { useSearchParam } from 'react-use';

export const Android = withRouter(function({title}: any) {
    const [loading, setLoading] = React.useState(false)
    const [keyword, setKeyword] = React.useState<string>('')

    // const {  } = useParams<any>()
    const sdkVersion = useSearchParam('sdk_version')
    const sdkId = useSearchParam('sdk_id')
    // console.log(sdk_version, sdk_id)
    const history = useHistory()
    const editLink = (id: string) => `/network_editor/android/${id}?sdk_version=${sdkVersion}`

    const onCell = (record: any) => {
        return {
            onClick: (event: any) => {
                history.push(editLink(record.id))
            }
        };
    }
    const addOnCell = (column: any) => ({ ...column, onCell, className: 'ant-table-pointer' })
    const makeColumn = pipe(mapColumn, addOnCell)

    const columns = [
        {
            ...makeColumn(networkAndroidAttribute.adNetworkVersionName),
            sorter: {
                compare: compareBy('adNetworkVersionName'),
                multiple: 1,
            },
            width: 200,
            ellipsis: true,
        },
        // {
        //     key: 'id',
        //     dataIndex: 'id',
        //     title: "ID"
        // },
        
        
        // {
        //     key: 'name',
        //     title: "英文名",
        //     render: (record: any) => (
        //         <div>{record.name}{record.nameCn ? `(${record.nameCn})` : ''}</div>
        //     )
        // },
        // ...networkAndroidAttributes
            // .filter((column: any) => !column.hideInList)
        ...[
            networkAndroidAttribute.nameEn,
            networkAndroidAttribute.identification,
            networkAndroidAttribute.adTypes,
            networkAndroidAttribute.region,
            // networkAndroidAttribute.androidSupportCompatible,
            // networkAndroidAttribute.androidXCompatible,
            networkAndroidAttribute.isAndroidSupportOrX,
        ]
            .map(mapColumn)
            .map(addOnCell)
        ,
        {
            title: '操作',
            key: 'x',
            width: 100,
            render: (props: any) => {
                return (
                    <Fragment>
                        <Link to={editLink(props?.id)}>
                            <Button type="text" icon={<EditOutlined />} />
                        </Link>
                        {/* <Link to={'/network_editor/android/copy/' + props?.id}>
                            <Button type="text" icon={<CopyOutlined />} />
                        </Link> */}
                        <ConfirmPop
                            onOk={handleDelete(props?.id)}
                            title='确认删除'
                        >
                            <Button icon={<DeleteOutlined />} type="text" danger />
                        </ConfirmPop>
                    </Fragment>
                )
            }
        },
        
    ]

    const requestDelete = useRequest(Services.androidNetwork.delete)
    const handleDelete = (id: any) => () => {
        return requestDelete({adNetworkId: id})
            .then((res: any) => {
                message.success('删除成功')
                fetchList()
            })
            .finally(() => {
                setLoading(false)
            })
    }


    const [dataSource, setDataSource] = React.useState<any>([])

    // const handleEdit = () => {
    // }

    const requestList = useRequest(Services.androidNetwork.list)
    const fetchList = () => {
        setLoading(true)
        requestList({
            sdkId
        })
            .then(setDataSource)
            .finally(() => setLoading(false))
    }
    React.useEffect(() => {
        fetchList()
    }, [])

    const [IsAndroidSupportOrXRadio, isAndroidSupportOrX]: any = useRadioButton({
        options: [
            {label: '不限', value: '0'},
            {label: '支持Support', value: '1'},
            {label: '支持AndroidX', value: '2'},
        ],
        defaultValue: '0'
    })
    // const [IsAndroidXRadio, androidXCompatible]: any = useRadioButton({
    //     options: [
    //         {label: '不限', value: ''},
    //         {label: 'AndroidX', value: '1'},
    //         {label: '非AndroidX', value: '0'},
    //     ]
    // })

    // const [IsAndroidSupportRadio, androidSupportCompatible]: any = useRadioButton({
    //     options: [
    //         {label: '不限', value: ''},
    //         {label: 'Support', value: '1'},
    //         {label: '非Support', value: '0'},
    //     ]
    // })

    const [RegionRadio, region]: any = useRadioButton({
        options: [
            {label: '不限', value: '0'},
            {label: '国内', value: '1'},
            {label: '海外', value: '2'},
        ],
        defaultValue: '0'
    })

    const filterDataSource = pipe(
        filter((item: any) => {
            return !!~item.adNetworkVersionName.toLowerCase()?.indexOf(keyword.toLowerCase()) ||
                !!~item.nameEn.toLowerCase()?.indexOf(keyword.toLowerCase())
        }),
        // filter((item: any) => androidXCompatible === '' || item.androidXCompatible === androidXCompatible),
        // filter((item: any) => androidSupportCompatible === '' || item.androidSupportCompatible === androidSupportCompatible),
        filter((item: any) => isAndroidSupportOrX === '0' || item?.isAndroidSupportOrX.toString() === isAndroidSupportOrX),
        filter((item: any) => region === '0' || item?.region.toString() === region),
    ) 

    networkAndroidAttributes.filter((column: any) => !!column.hideInList)

    const ptitle = (sdkVersion ? `Android SDK ${sdkVersion} - ` : '') + title

    return <div>
        <PageHeader 
            title={ptitle}
            onBack={() => history.goBack()}
        />
        <Space align="center" style={{marginBottom: '10px'}} wrap>
            <Link to={`/network_editor/android?sdk_id=${sdkId}&sdk_version=${sdkVersion}`}>
                <Button type="primary">
                    添加广告网络
                </Button>
            </Link>

            <Input onChange={e => setKeyword(e.target.value)} placeholder="版本号/英文名" />

            {/* <IsAndroidXRadio /> */}
            {/* <IsAndroidSupportRadio /> */}
            <IsAndroidSupportOrXRadio />
            <RegionRadio />
        </Space>

        <Table 
            rowKey="id"
            size="small"
            dataSource={filterDataSource(dataSource) as object[]} 
            columns={columns}
            loading={loading}
            pagination={false}
            expandable={{
                expandedRowRender: (record: any) => {
                    return (
                        <Fragment>
                            {
                                networkAndroidAttributes
                                    .filter((column: any) => !!column.hideInList)
                                    .map((column: any) => (<Fragment key={column.key}>
                                            <p className="m0"><h3 className="m0">{column.title}</h3></p>
                                            {
                                                record[column.key].toString().split(/\n/).map((s: any, i: any) => 
                                                    <p className="m0" key={column.key + '_' + i}>{s}</p>
                                                )
                                            }
                                            <br />
                                        </Fragment>
                                    ))
                            }
                        </Fragment>
                    )
                },
                rowExpandable: (record: any) => record.name !== 'Not Expandable',
            }}
        />
    </div>
})